@if (loading) {
    <div class="spacer">
        <usana-spinner [show]="loading" [delay]="100"></usana-spinner>
    </div>
}
@if (!loading && errorTag) {
    <div class="container text-center" [translate]="errorTag">
    </div>
}
<br/>
